const initialState = {
  isOpen: false,
  state: null,
}

const playerInterfaceModalReducer = (initState = initialState, action) => {
  const { type, payload } = action
  switch (type) {
    case 'SET_INTERFACE_MODAL': {
      return {
        ...initState,
        isOpen: payload?.isOpen,
        state: payload?.state,
      }
    }

    default:
      return initState
  }
}

export default playerInterfaceModalReducer
